import { render, staticRenderFns } from "./video.vue?vue&type=template&id=67407f48"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67407f48')) {
      api.createRecord('67407f48', component.options)
    } else {
      api.reload('67407f48', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=67407f48", function () {
      api.rerender('67407f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/media-types/video.vue"
export default component.exports